// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormControl } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { FileService } from "../../services/file.service";
import { File } from "../../models/file";
import { FolderService } from "../../services/folder.service";
import { Folder } from "../../models/folder";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import swal from "sweetalert2";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { Methods } from "../../shared/methods";
import { of } from "rxjs";

export interface UserList {
  value: string;
  name: string;
}

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  selector: "app-listfiles-cmp",
  templateUrl: "listfiles.component.html",
  styleUrls: ["file-upload.component.scss"],
  providers: [UserService, FileService, FolderService],
})
export class ListfilesComponent implements OnInit, AfterViewInit {
  // State for dropzone CSS toggling
  isHovering: boolean;

  public loading: boolean = true;
  public mtds: Methods = new Methods();
  public options: Array<any> = [];
  public data: DinamicData = new DinamicData([
    // "check",
    "ID",
    "Type",
    "Vendor",
    "Created Date",
    "Actions",
  ]);

  public bulk: Array<any> = [];

  name: string;
  animal: string;
  public dataTable: DataTable;
  public privilegio;
  sexos = [
    { value: "1", viewValue: "Hombre" },
    { value: "0", viewValue: "Mujer" },
  ];
  public pacientes: Array<User>;
  public files: Array<File>;
  public folder: Array<Folder>;
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public dataTablePOSearch: DataTable;
  public order = 0;
  public searchString;
  public user;
  public folderinterno;
  public file;
  public status_user;
  myControl = new FormControl();
  myControlClientes = new FormControl();
  public clientes;

  public userlogged;
  public apiCompany;

  public filtros = [];
  public campoBusqueda = "";

  public itemsPorPagina = "10";
  public paginaActual = 1;
  public totalItems = 0;
  public totalPaginas = 1;

  constructor(
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private titleService: Title,
    private _router: Router,
    private _userService: UserService,
    private _fileService: FileService,
    private _folderService: FolderService
  ) {
    this.titleService.setTitle("CV Files");
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    this.options = this.mtds.colopt(this.data.headers, [false]);

    if (this.token) {
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.userlogged = response.data;

            this.apiCompany = this.userlogged.companyLinked.apiToken;
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      this.getAllPacientes();
    }

    this.dataTablePOSearch = {
      headerRow: ["Folder Name", "Actions"],
      footerRow: ["Folder Name", "Actions"],

      dataRows: [],
    };
  }

  action(e) {
    console.log(e);
    switch (e.action) {
      case "Show":
        this._router.navigate(["/tables/listfiles", e.id]);
        break;
      case "Remove":
        this.deleteFolderfirst(e.id);
        break;
      default:
        break;
    }
  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  selectUserPermission(e) {
    console.log(e);
  }

  public showMsgPOSearchingNotResults = 0;
  public showsearchPOResults = 0;

  public showposearch = 0;
  public advancedpotext = "";

  showposrch() {
    if (this.showposearch) this.showposearch = 0;
    else this.showposearch = 1;
  }

  goFolder(folder) {
    // console.log(folder);
    // this._router.navigate(['/tables/listfiles', folder]);
    window.location.href = "/tables/listfiles/" + folder;
  }

  searchPO() {
    $("#showMsgPOSearching").show();
    this.dataTablePOSearch.dataRows = [];
    this.showMsgPOSearchingNotResults = 0;

    this._fileService
      .searchPO(this.privilegio.sub, this.advancedpotext, this.apiCompany)
      .subscribe(
        (response) => {
          $("#showMsgPOSearching").hide();
          console.log(response);
          console.log(response.length);
          if (response.length > 0) {
            this.showsearchPOResults = 1;
            this.showMsgPOSearchingNotResults = 0;
          } else {
            this.showsearchPOResults = 0;
            this.showMsgPOSearchingNotResults = 1;
          }
          response.forEach(
            function (element) {
              console.log(element.file);
              this.dataTablePOSearch.dataRows.push([
                element.id,
                element.folderName,
                "",
              ]);
            }.bind(this)
          );
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  deleteFolderfirst(folder) {
    swal
      .fire({
        title: "Are you sure to delete this folder?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },

        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then((result) => {
        if (result.value) {
          this.deleteFolder(folder);
        }
      });
  }

  deleteFolder(id) {
    console.log(id + "aqui");
    this._folderService.deleteFolder(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          swal.fire({
            title: "Folder has been removed successfully",
            text: "",
            buttonsStyling: false,

            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.getAllPacientes();
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    this._folderService.deleteFolder(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);

          // this.getFiles(this.idFolder);
          console.log("deleted");
          this.loading = false;
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  showSwal(type) {
    if (type === "success-message") {
      swal.fire({
        title: "Folder has been created",
        text: "",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "warning-message-and-confirmation") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to revert this!",

          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",

            customClass: {
              confirmButton: "btn btn-success",
            },

            buttonsStyling: false,
          });
        });
    } else if (type === "warning-message-and-cancel") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to recover this imaginary file!",

          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, keep it",

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          buttonsStyling: false,
        })
        .then(
          function () {
            swal.fire({
              title: "Deleted!",
              text: "Your imaginary file has been deleted.",

              customClass: {
                confirmButton: "btn btn-success",
              },

              buttonsStyling: false,
            });
          },
          function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === "cancel") {
              swal.fire({
                title: "Cancelled",
                text: "Your imaginary file is safe :)",

                customClass: {
                  confirmButton: "btn btn-info",
                },
                buttonsStyling: false,
              });
            }
          }
        );
    } else if (type === "custom-html") {
      swal.fire({
        title: "HTML example",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
        html:
          "You can use <b>bold text</b>, " +
          '<a href="http://github.com">links</a> ' +
          "and other HTML tags",
      });
    } else if (type === "auto-close") {
      swal
        .fire({
          title: "Auto close alert!",
          text: "I will close in 2 seconds.",
          timer: 2000,
          showConfirmButton: false,
        })
        .then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === "timer") {
              console.log("I was closed by the timer");
            }
          }
        );
    } else if (type === "input-field") {
      swal
        .fire({
          title: "Input something",
          html:
            '<div class="form-group">' +
            '<input id="input-field" type="text" class="form-control" />' +
            "</div>",
          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          buttonsStyling: false,
        })
        .then(function (result) {
          swal.fire({
            html:
              "You entered: <strong>" + $("#input-field").val() + "</strong>",

            customClass: {
              confirmButton: "btn btn-success",
            },

            buttonsStyling: false,
          });
        });
    }
  }

  openNuevoFolder(): void {
    console.log("openNuevoFolder fired up");
    this.folderinterno = new Folder(1, "", "", "", 0, "", 0, 0, 1, 0);
    let dialogRef = this.dialog.open(NewFolder, {
      width: "80%",
      data: { folder: this.folderinterno },
    });

    dialogRef.afterClosed().subscribe((result) => {
      //  result.folder.user_id = result.user_id.value;
      console.log(result);
      //console.log(result.folder);

      this._folderService.create(this.token, result).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.showSwal("success-message");
            //this.animal = result;
            this.getAllPacientes();
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  getAllPacientes(e = null, newfilter = true) {
    this.loading = true;
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      let typeFolders = "";

      if (
        this.privilegio.level == "ADMINISTRATOR" ||
        this.privilegio.level == "MANAGER" ||
        this.privilegio.level == "PURCHASINGREP" ||
        this.privilegio.level == "worker" ||
        this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
        this.privilegio.level == "TECHREP" ||
        this.privilegio.level == "CLERICALREP"
      ) {
        typeFolders = "ALL";
      } else if (this.privilegio.level == "worker") {
        typeFolders = "ALL";
      } else {
        typeFolders = "VENDOR";
      }

      this.loading = true;
      this.data.rows = [];
      this._folderService
        .getFolders(
          this.token,
          e !== null ? e.page : 1,
          e !== null ? e.perPage : 10,
          e !== null
            ? (this.campoBusqueda = e.search)
            : (this.campoBusqueda = ""),
          this.filtros,
          typeFolders
        )
        .subscribe(
          (response) => {
            //Redirect Customers to Folder
            if (
              this.identity.role === "customer" ||
              this.identity.role === "VENDOR"
            ) {
              // TODO: implement MESSAGE
              if (response.data.length > 0) {
                this._router.navigate([
                  "/tables/listfiles",
                  response.data[0].id,
                ]);
              }
            }

            if (response.status == "success") {
              this.paginaActual = Number(response.page_actual);
              this.itemsPorPagina = String(response.items_per_page);
              this.totalItems = Number(response.total_items_count);
              this.totalPaginas = Number(response.total_pages);

              if (newfilter) {
                this.filtros = [
                  //null,
                  {
                    key: "filter_id",
                    title: "ID",
                    value: "",
                    type: "contains",
                    key_type: "filter_id_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  null,
                  {
                    key: "filter_vendor",
                    title: "Vendor",
                    value: "",
                    type: "contains",
                    key_type: "filter_vendor_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_date",
                    title: "Date",
                    value: "",
                    type: "startswith",
                    key_type: "filter_date_type",
                    type_options: [
                      {value: "contains", name: "Contains"},
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  null,
                ];
              }

              this.pacientes = response.data;

              let actionButtons = [
                { icon: "remove_red_eye", action: "Show", color: "info" },
              ];

              if (
                this.identity.role === "ADMINISTRATOR" ||
                this.identity.role === "MANAGER"
              ) {
                actionButtons.push({
                  icon: "delete_outline",
                  action: "Remove",
                  color: "danger",
                });
              }

              for (let element of response.data) {
                this.data.rows.push([
                  // new Cell(element.id, { type: "checkbox" }),
                  new Cell(element.id),
                  new Cell("", { icon: "folder" }),
                  new Cell(element.name),
                  new Cell(this.formatDateTimeUS(element.createdAt)),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              }

              this.dataTable = {
                headerRow: ["Type", "ID", "Client Name", "User", "Actions"],
                footerRow: ["Type", "ID", "Client Name", "User", "Actions"],
                dataRows: [],
              };

              this.pacientes.forEach(
                function (element) {
                  let username;
                  if (element.user && element.user.name && element.user.surname)
                    username = element.user.name + " " + element.user.surname;
                  this.dataTable.dataRows.push([
                    element.id,
                    element.name,
                    username,
                    "",
                  ]);
                }.bind(this)
              );

              //total paginas
              this.pages = [];
              for (let i = 0; i < response.total_pages; i++) {
                this.pages.push(i);
              }

              //pagina anterior
              if (page >= 2) {
                this.pagePrev = page - 1;
              } else {
                this.pagePrev = page;
              }

              //pagina siguiente
              if (page < response.total_pages) {
                this.pageNext = page + 1;
              } else {
                this.pageNext = page;
              }
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
            this.loading = false;
          },
          (error) => {
            console.log(<any>error);
            this.loading = false;
          }
        );
    });
  }

  formatDateTimeUS(dateString: string | null): string {
    if (!dateString) return ''; 
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; 
  
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
  
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
  
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }
  
  ngAfterViewInit() {}
}

@Component({
  selector: "new-folder",
  templateUrl: "new-folder.html",
  providers: [UserService, FileService, FolderService],
})
export class NewFolder implements OnInit, AfterViewInit {
  public userinterno;
  public loading: boolean = false;
  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public pacientes;
  public folder;
  public productosResponse;
  myControl = new FormControl();
  myControlClientes = new FormControl();
  public selectedUsers: any[] = [];
  public usertoAssign: Array<any> = [];
  users = new FormControl();

  public permissionsShow;
  sexos = [
    { value: "1", viewValue: "Male" },
    { value: "0", viewValue: "Female" },
  ];
  public groupSelected;
  groups: UserList[] = [];

  clientes: UserList[] = [];

  filteredGroups: Observable<UserList[]>;
  filteredClientes: Observable<UserList[]>;

  constructor(
    public dialogRef: MatDialogRef<NewFolder>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _fileService: FileService,
    private _folderService: FolderService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.folder = data;
    this.loading = true;
    this.folder.permissions = this.folder.permissions || [];
    this.permissionsShow = [];
    console.log(this.folder.permissions);
    this._userService.getAllUsers(this.token).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.loading = false;
          this.pacientes = response.data;
          console.log(this.pacientes);
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  ngOnInit() {
    console.log("5555");
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
    }

    this.getListUsers("VENDOR");

    this.filteredClientes = this.myControlClientes.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterClientes(name) : this.clientes.slice()))
    );
    this.filteredGroups = this.myControl.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value?.name || "")),
      map((name) => (name ? this._filterGroups(name) : this.groups.slice()))
    );
    console.log(this.filteredClientes);
    console.log(this.clientes);
  }
  pipeusers(user) {
    console.log(user.name, "user");
    // let fullname;
    // this.titleFormHDMode == "Edit"
    //   ? (fullname = `${rep}`)
    //   : (fullname = `${rep.name} ${rep.surname}`);
    // // return `${rep.name} ${rep.surname}`
    return user.name;
  }
  ngAfterViewInit() {}
  onInputFocus(): void {
    // Ejecuta el filtro para mostrar todas las opciones cuando el input tiene foco
    this.filteredGroups = of(this.groups);
  }
  onHumanSelected(option) {
    console.log(option, "OPTTT");
    this.folder.group_permissions = option.value.id;
    console.log("groupsel", this.folder.group_permissions);
  }
  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }
  private _filterGroups(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.groups.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  getListUsers(type) {
    this.loading = true;
    this._userService.getAllUsersLite(this.token, type).subscribe(
      (response) => {
        console.log("lite");
        console.log(response);
        this.loading = false;
        if (response.status == "success") {
          if (type == "VENDOR") {
            response.data.forEach(
              function (element) {
                this.usertoAssign.push({
                  value: element.id,
                  name:
                    element.name + " " + element.surname + " # " + element.id,
                });
              }.bind(this)
              // function (element) {
              //   this.clientes.push({
              //     value: element.id,
              //     name:
              //       element.name + " " + element.surname + " # " + element.id,
              //   });
              // }.bind(this)
            );
          }
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  selectPacient(event) {
    //console.log(event.value);

    this._userService.getUser(this.token, event.value).subscribe(
      (response) => {
        if (response.status == "success") {
          this.userinterno = response.data;
          console.log(this.userinterno);
          this.folder.user_id = this.userinterno.id;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  deletePermiso(borrar) {
    var res = borrar.split("#");
    res = res[1].trim();
    res = parseInt(res);

    console.log(this.folder.permissions);

    for (var i = this.folder.permissions.length - 1; i >= 0; i--) {
      console.log(this.folder.permissions[i]);
      if (this.folder.permissions[i] === res) {
        this.folder.permissions.splice(i, 1);
      }
    }

    for (var i = this.permissionsShow.length - 1; i >= 0; i--) {
      console.log(this.permissionsShow[i]);
      if (this.permissionsShow[i] === borrar) {
        this.permissionsShow.splice(i, 1);
      }
    }

    console.log(this.folder.permissions);
  }

  selectUserPermission() {
    let userSelected = $("#nameCliente").val();

    console.log(this.folder.user_id);
    this.folder.permissions.push(this.folder.user_id.value);
    this.permissionsShow.push(this.folder.user_id.name + "");
    console.log(this.folder.permissions);
  }

  addItem() {
    console.log("add item");
  }

  onNoClick(): void {}
}
